class Throttle {
    constructor() {
        this.enabled = true
    }
    run(fn) {
        if (this.enabled) {
            this.enabled = false
            window.requestAnimationFrame(fn)
            this.enabled = true
        }
    }
}

export default fn => {
    if (typeof (fn) !== 'function') return
    new Throttle().run(fn)
}